export default "__VITE_ASSET__BOYmFLfZ__"